<ng-container *ngIf="currentState$ | async as state">
  <ng-container [ngSwitch]="state">

    <ng-container *ngSwitchCase="AppState.Active">

      <ng-container *ngIf="currentView$ | async as view">
        <ng-container [ngSwitch]="view">
          <ng-container *ngSwitchCase="AppView.Dashboard">
            <da-dashboard />
          </ng-container>
          <ng-container *ngSwitchCase="AppView.Empty">
            <da-empty />
          </ng-container>
          <ng-container *ngSwitchCase="AppView.ForgotPassword">
            <fu-forgot-password />
          </ng-container>
          <ng-container *ngSwitchCase="AppView.SignIn">
            <fu-sign-in />
          </ng-container>
        </ng-container>
      </ng-container>
      
    </ng-container>

    <ng-container *ngSwitchCase="AppState.Inactive">
      <da-inactive />
    </ng-container>

    <ng-container *ngSwitchCase="AppState.Loading">
      <ui-app-loader />
    </ng-container>

  </ng-container>
</ng-container>
